import React from 'react';
import { SpaceBetween } from '@cloudscape-design/components';

const WorkflowPropertiesWidgetHelp = () => (
  <SpaceBetween size="s">
    <p>Edit high‑level attributes of the selected workflow.</p>
    <ul>
      <li><b>Name</b>: Admin display label (not end‑user facing).</li>
      <li><b>Status</b>: draft | active | inactive. Change requires Save.</li>
      <li><b>Publish</b>: Save your changes, then review the differences from the current public intake. Publish reviewed changes replaces that intake and retains the previous version for recovery. If the form changed after review, refresh the comparison. If a response was interrupted, retry the same request to confirm its result.</li>
      <li><b>Unsaved</b> badge appears when local edits differ from stored values.</li>
    </ul>
    <p>Creation / Updated timestamps are read‑only audit fields.</p>
  </SpaceBetween>
);

WorkflowPropertiesWidgetHelp.aiContext = 'Workflow Properties widget: edit name/status and save before publishing. Publish opens the current-versus-candidate comparison. Review content, routing, field and upload changes, then choose Publish reviewed changes. A changed workflow/library or current publication requires a refreshed comparison. The previous version is retained for operator recovery. Retry an interrupted request in the same dialog; never treat an unconfirmed publication as success. These controls do not replace applicant journey testing.';
export default WorkflowPropertiesWidgetHelp;
